export const mockDomains = [
  {
    id: 1,
    name: "TechStartup.io",
    price: 5000,
    aiValuation: { min: 4500, max: 6200, confidence: 89 },
    status: "listed",
    listingType: ["buyNow", "offers", "trade"],
    tld: "io",
    category: "tech",
    length: 11,
    listedBy: "domainKing",
    listedAt: "2024-01-15T14:30:00Z",
    views: 1234,
    likes: 87,
    likedBy: ["demoUser", "techPro"],
    comments: 12,
    trending: true,
    isNew: false,
    badges: ["hot", "premium"],
    seoMetrics: {
      searchVolume: 12100,
      domainAuthority: 15,
      backlinks: 0,
      keywords: ["tech", "startup", "business"]
    },
    aiAnalysis: {
      brandability: 5,
      memorability: 4,
      keywordValue: 4,
      tldPremium: 4,
      marketTrend: 4,
      overallScore: 89
    },
    registrationInfo: {
      registered: "2019",
      expires: "2026-12",
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      { date: "2024-01-10", price: 6000 },
      { date: "2024-01-12", price: 5500 },
      { date: "2024-01-15", price: 5000 }
    ],
    bids: [
      { username: "buyer123", amount: 4800, timestamp: "2024-01-15T16:30:00Z" },
      { username: "trader456", amount: 4500, timestamp: "2024-01-15T11:20:00Z" }
    ],
    openToTrades: true,
    tradePreferences: "Similar value domains (.com only), Tech/Startup related"
  },
  {
    id: 2,
    name: "AIRevolution.com",
    price: 12000,
    aiValuation: { min: 10500, max: 13500, confidence: 92 },
    status: "listed",
    listingType: ["buyNow", "offers"],
    tld: "com",
    category: "tech",
    length: 12,
    listedBy: "domainKing",
    listedAt: "2024-01-10T09:00:00Z",
    views: 2341,
    likes: 156,
    likedBy: ["demoUser"],
    comments: 23,
    trending: true,
    isNew: false,
    badges: ["hot", "premium"],
    seoMetrics: {
      searchVolume: 24500,
      domainAuthority: 0,
      backlinks: 0,
      keywords: ["ai", "artificial intelligence", "revolution"]
    },
    aiAnalysis: {
      brandability: 5,
      memorability: 5,
      keywordValue: 5,
      tldPremium: 5,
      marketTrend: 5,
      overallScore: 92
    },
    registrationInfo: {
      registered: "2018",
      expires: "2025-08",
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      { date: "2024-01-05", price: 15000 },
      { date: "2024-01-08", price: 13000 },
      { date: "2024-01-10", price: 12000 }
    ],
    bids: [
      { username: "aiEnthusiast", amount: 11500, timestamp: "2024-01-14T10:00:00Z" },
      { username: "techInvestor", amount: 11000, timestamp: "2024-01-13T15:30:00Z" }
    ],
    openToTrades: false,
    tradePreferences: null
  },
  {
    id: 3,
    name: "CryptoHub.com",
    price: 8500,
    aiValuation: { min: 7800, max: 9200, confidence: 85 },
    status: "listed",
    listingType: ["buyNow", "offers", "trade"],
    tld: "com",
    category: "crypto",
    length: 10,
    listedBy: "cryptoQueen",
    listedAt: "2024-01-14T11:00:00Z",
    views: 987,
    likes: 64,
    likedBy: [],
    comments: 8,
    trending: false,
    isNew: true,
    badges: ["new"],
    seoMetrics: {
      searchVolume: 18200,
      domainAuthority: 0,
      backlinks: 0,
      keywords: ["crypto", "cryptocurrency", "bitcoin"]
    },
    aiAnalysis: {
      brandability: 4,
      memorability: 4,
      keywordValue: 5,
      tldPremium: 5,
      marketTrend: 4,
      overallScore: 85
    },
    registrationInfo: {
      registered: "2020",
      expires: "2027-03",
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      { date: "2024-01-14", price: 8500 }
    ],
    bids: [],
    openToTrades: true,
    tradePreferences: "Crypto or tech domains, flexible on value"
  },
  {
    id: 4,
    name: "SmartData.ai",
    price: 6200,
    aiValuation: { min: 5500, max: 7000, confidence: 88 },
    status: "listed",
    listingType: ["buyNow", "offers"],
    tld: "ai",
    category: "tech",
    length: 9,
    listedBy: "dataScientist",
    listedAt: "2024-01-13T16:45:00Z",
    views: 654,
    likes: 42,
    likedBy: [],
    comments: 5,
    trending: false,
    isNew: true,
    badges: ["new"],
    seoMetrics: {
      searchVolume: 8900,
      domainAuthority: 0,
      backlinks: 0,
      keywords: ["smart", "data", "analytics"]
    },
    aiAnalysis: {
      brandability: 5,
      memorability: 4,
      keywordValue: 4,
      tldPremium: 4,
      marketTrend: 5,
      overallScore: 88
    },
    registrationInfo: {
      registered: "2021",
      expires: "2026-01",
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      { date: "2024-01-13", price: 6200 }
    ],
    bids: [
      { username: "mlExpert", amount: 5800, timestamp: "2024-01-14T12:00:00Z" }
    ],
    openToTrades: false,
    tradePreferences: null
  },
  {
    id: 5,
    name: "HealthTrack.io",
    price: 4200,
    aiValuation: { min: 3800, max: 4800, confidence: 82 },
    status: "listed",
    listingType: ["buyNow", "offers", "trade"],
    tld: "io",
    category: "health",
    length: 11,
    listedBy: "healthTechPro",
    listedAt: "2024-01-12T08:30:00Z",
    views: 432,
    likes: 28,
    likedBy: [],
    comments: 3,
    trending: false,
    isNew: false,
    badges: [],
    seoMetrics: {
      searchVolume: 6500,
      domainAuthority: 0,
      backlinks: 0,
      keywords: ["health", "track", "fitness"]
    },
    aiAnalysis: {
      brandability: 4,
      memorability: 4,
      keywordValue: 3,
      tldPremium: 4,
      marketTrend: 4,
      overallScore: 82
    },
    registrationInfo: {
      registered: "2020",
      expires: "2025-12",
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      { date: "2024-01-08", price: 4500 },
      { date: "2024-01-12", price: 4200 }
    ],
    bids: [],
    openToTrades: true,
    tradePreferences: "Health/wellness related domains"
  },
  {
    id: 6,
    name: "DevTools.com",
    price: 15000,
    aiValuation: { min: 13000, max: 17000, confidence: 91 },
    status: "listed",
    listingType: ["buyNow"],
    tld: "com",
    category: "tech",
    length: 8,
    listedBy: "domainKing",
    listedAt: "2024-01-08T10:00:00Z",
    views: 3421,
    likes: 234,
    likedBy: ["demoUser", "techPro", "startupGuru"],
    comments: 45,
    trending: true,
    isNew: false,
    badges: ["hot", "premium"],
    seoMetrics: {
      searchVolume: 45000,
      domainAuthority: 0,
      backlinks: 0,
      keywords: ["dev", "developer", "tools"]
    },
    aiAnalysis: {
      brandability: 5,
      memorability: 5,
      keywordValue: 5,
      tldPremium: 5,
      marketTrend: 4,
      overallScore: 91
    },
    registrationInfo: {
      registered: "2017",
      expires: "2026-06",
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      { date: "2024-01-01", price: 18000 },
      { date: "2024-01-05", price: 16000 },
      { date: "2024-01-08", price: 15000 }
    ],
    bids: [],
    openToTrades: false,
    tradePreferences: null
  },
];

// Additional domain names to generate
const additionalDomainNames = [
  "CloudBase.io", "StartupLab.com", "TechHub.ai", "DataFlow.io",
  "AppForge.com", "CodeCraft.io", "WebPro.net", "SmartLink.io",
  "CryptoVault.com", "BlockChain.io", "NFTMarket.io", "GameZone.com",
  "FinanceHub.com", "PaymentPro.io", "TradeSmart.com", "InvestNow.io",
  "HealthPlus.com", "MediCare.io", "FitTrack.app", "WellBeing.io",
  "EduLearn.com", "StudyHub.io", "OnlineCourse.com", "SkillUp.io",
  "MarketPlace.co", "ShopNow.com", "BizGrowth.io", "SalesBoost.com"
];

// Auto-generate additional domains
additionalDomainNames.forEach((name, index) => {
  const parts = name.split('.');
  const domain = parts[0];
  const tld = parts[1];

  const categories = ["tech", "crypto", "finance", "health", "education", "business"];
  const sellers = ["domainKing", "cryptoQueen", "techPro", "startupGuru", "dataScientist"];

  const price = Math.floor(Math.random() * 10000) + 1000;
  const variance = 0.2;

  mockDomains.push({
    id: mockDomains.length + 1,
    name,
    price,
    aiValuation: {
      min: Math.floor(price * (1 - variance)),
      max: Math.floor(price * (1 + variance)),
      confidence: Math.floor(Math.random() * 20) + 75
    },
    status: "listed",
    listingType: Math.random() > 0.5 ? ["buyNow", "offers"] : ["buyNow"],
    tld,
    category: categories[Math.floor(Math.random() * categories.length)],
    length: domain.length,
    listedBy: sellers[Math.floor(Math.random() * sellers.length)],
    listedAt: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
    views: Math.floor(Math.random() * 2000) + 100,
    likes: Math.floor(Math.random() * 100) + 10,
    likedBy: [],
    comments: Math.floor(Math.random() * 20),
    trending: Math.random() > 0.8,
    isNew: Math.random() > 0.7,
    badges: [],
    seoMetrics: {
      searchVolume: Math.floor(Math.random() * 50000) + 1000,
      domainAuthority: 0,
      backlinks: 0,
      keywords: []
    },
    aiAnalysis: {
      brandability: Math.floor(Math.random() * 3) + 3,
      memorability: Math.floor(Math.random() * 3) + 3,
      keywordValue: Math.floor(Math.random() * 3) + 3,
      tldPremium: Math.floor(Math.random() * 3) + 3,
      marketTrend: Math.floor(Math.random() * 3) + 3,
      overallScore: Math.floor(Math.random() * 20) + 75
    },
    registrationInfo: {
      registered: String(2015 + Math.floor(Math.random() * 8)),
      expires: `202${5 + Math.floor(Math.random() * 3)}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}`,
      registrar: "DomainFlip Escrow"
    },
    priceHistory: [
      {
        date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        price: Math.floor(price * 1.1)
      },
      {
        date: new Date().toISOString().split('T')[0],
        price
      }
    ],
    bids: [],
    openToTrades: Math.random() > 0.6,
    tradePreferences: Math.random() > 0.6 ? "Open to fair trades" : null
  });
});

export default mockDomains;
